import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import Section, { SectionHeader, SectionTitle, SectionBody } from 'components/common/Section';
import Button from 'components/common/Button';

const styles = theme => ({
  sectionBody: {
    padding: '60px 80px',
  },
  article: {
    border: `1px solid ${theme.palette.primary.A400}`,
    padding: 24,
    marginTop: 24,
  },
  table: {
    marginTop: 24,
  },
  tableRow: {
    height: 42,
  },
  tableCell: {
    borderLeft: `1px solid ${theme.palette.primary.A400}`,
    borderRight: `1px solid ${theme.palette.primary.A400}`,
    borderTop: `1px solid ${theme.palette.primary.A400}`,
  },
});

const PaymentDetails = ({ classes }) => (
  <Section className={classes.section}>
    <SectionHeader fixed>
      <SectionTitle>
        Payment Plan Details
      </SectionTitle>
      <Button
        href="/settings/payment"
        variant="raised"
        color="primary"
      >
        Close
      </Button>
    </SectionHeader>
    <SectionBody className={classes.sectionBody}>
      <Typography variant="subheading" gutterBottom>
        CHC Services:
      </Typography>
      <Grid
        container
        spacing={24}
      >
        <Grid item xs={6}>
          <Typography color="secondary" gutterBottom>
            Batch Transactions:
          </Typography>
          <Typography>
            - Professional (Medical) Claims <br />
            - Electronic Remittance Advice (&quot;ERA&quot;) <br />
            - Print to Paper Claims <br />
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography color="secondary" gutterBottom>
            Real-Time Transactions:
          </Typography>
          <Typography>
            - Eligibility Inquiry and Response<br />
            - Claim Status Inquiry and Response<br />
          </Typography>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={24}
      >
        <Grid item xs={6}>
          <div className={classes.article}>
            <Typography variant="subheading">
              One-time Implementation Fees
            </Typography>
            <Typography gutterBottom>
              Transaction Types Implementation Fees
            </Typography>
            <Typography variant="caption">
              - <strike>Professional (Medical) Claims</strike> <br />
              - <strike>Electronic Remittance Advice</strike> <br />
              - <strike>Real-Time Transactions</strike>
            </Typography>
          </div>
        </Grid>
        <Grid item xs={6}>
          <div className={classes.article}>
            <Typography variant="subheading">
              Monthly service fees
            </Typography>
            <Typography gutterBottom>
              $549 Unlimited Edition
            </Typography>
            <Typography variant="caption">
              - 24/7 Support <br />
              - Billing Support <br />
              - All Features
            </Typography>
          </div>
        </Grid>
      </Grid>
      <Table className={classes.table}>
        <TableHead>
          <TableRow className={classes.tableRow}>
            <TableCell className={classes.tableCell}>Monthly Volume of
              Batch Transactions</TableCell>
            <TableCell className={classes.tableCell}>Per Transaction Fees</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow className={classes.tableRow}>
            <TableCell className={classes.tableCell}>0 - 1,500</TableCell>
            <TableCell className={classes.tableCell}>$0.35</TableCell>
          </TableRow>
          <TableRow className={classes.tableRow}>
            <TableCell className={classes.tableCell}>1,501 - 10,000</TableCell>
            <TableCell className={classes.tableCell}>$0.30</TableCell>
          </TableRow>
          <TableRow className={classes.tableRow}>
            <TableCell className={classes.tableCell}>10,001 - 25,000</TableCell>
            <TableCell className={classes.tableCell}>$0.28</TableCell>
          </TableRow>
          <TableRow className={classes.tableRow}>
            <TableCell className={classes.tableCell}>25,001 - 50,000</TableCell>
            <TableCell className={classes.tableCell}>$0.26</TableCell>
          </TableRow>
          <TableRow className={classes.tableRow}>
            <TableCell className={classes.tableCell}>50,001 - 100,000</TableCell>
            <TableCell className={classes.tableCell}>$0.25</TableCell>
          </TableRow>
          <TableRow className={classes.tableRow}>
            <TableCell className={classes.tableCell}>100,001 - 250,000</TableCell>
            <TableCell className={classes.tableCell}>$0.24</TableCell>
          </TableRow>
          <TableRow className={classes.tableRow}>
            <TableCell className={classes.tableCell}>250,001 - 500,000</TableCell>
            <TableCell className={classes.tableCell}>$0.22</TableCell>
          </TableRow>
          <TableRow className={classes.tableRow}>
            <TableCell className={classes.tableCell}>500,001 - 1,000,000</TableCell>
            <TableCell className={classes.tableCell}>$0.21</TableCell>
          </TableRow>
          <TableRow className={classes.tableRow}>
            <TableCell className={classes.tableCell}>In excess of 1,000,000</TableCell>
            <TableCell className={classes.tableCell}>$0.20</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </SectionBody>
  </Section>
);

PaymentDetails.propTypes = {
  classes: PropTypes.shape({
    section: PropTypes.string.isRequired,
    sectionBody: PropTypes.string.isRequired,
    typographyTitle: PropTypes.string.isRequired,
    button: PropTypes.string.isRequired,
    radioGroupFieldRoot: PropTypes.string.isRequired,
    formControlLabel: PropTypes.string.isRequired,
    formControlRoot: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(PaymentDetails);



// WEBPACK FOOTER //
// ./src/components/settings/PaymentPlanDetails/PaymentPlanDetails.js